/**
 * Orden (base → cima) de las capas de provincias/labels para dejarlas por encima
 * de los rasters y, tras cargar PMTiles, por encima de las parcelas.
 */
export const PROVINCE_LAYERS_TOP_ORDER = [
  'provinces-admin-hit-area',
  'provinces-admin-borders',
  'provinces-admin-hover-fill',
  'provinces-admin-hover-borders',
  'provinces-labels',
];

export function moveProvinceLayersToTop(map) {
  if (!map) return;
  PROVINCE_LAYERS_TOP_ORDER.forEach((id) => {
    if (map.getLayer(id)) map.moveLayer(id);
  });
}

/**
 * Toponimia del estilo base (OpenFreeMap). Vive en el style inicial, así que sin
 * reordenar queda debajo de todo lo que se agrega después (parcelas, edificios, pines).
 */
export const BASE_LABEL_LAYERS_TOP_ORDER = [
  'overlay-road-labels',
  'overlay-street-labels',
  'overlay-place-labels',
];

export function moveBaseLabelsToTop(map) {
  if (!map) return;
  BASE_LABEL_LAYERS_TOP_ORDER.forEach((id) => {
    if (map.getLayer(id)) map.moveLayer(id);
  });
}

/**
 * `moveLayer` sin beforeId manda al tope. El orden de las llamadas es el
 * stack final (último = cima): extras (pines) → provincias → toponimia.
 * Cada tesela nueva de parcelas se agrega arriba; hay que volver a subir esto.
 *
 * @param {object} map
 * @param {string[]} [extraLayerIds]
 */
export function moveForegroundLayersToTop(map, extraLayerIds = []) {
  if (!map) return;
  extraLayerIds.forEach((id) => {
    if (map.getLayer(id)) map.moveLayer(id);
  });
  moveProvinceLayersToTop(map);
  moveBaseLabelsToTop(map);
}
